function generateData(count, yrange) {
  var i = 0;
  var series = [];
  while (i < count) {
    var x = (i + 1).toString();
    var y =
      Math.floor(Math.random() * (yrange.max - yrange.min + 1)) + yrange.min;
    series.push({
      x: x,
      y: y,
    });
    i++;
  }
  return series;
}

var optionsh = {
  series: [],
  noData: {
    text: "Wählen Sie einen Standort aus ...",
  },
  chart: {
    height: 315,
    type: "heatmap",
    id: "depth_rew",
    animations: {
      enabled: false,
    },
  },
  plotOptions: {
    heatmap: {
      shadeIntensity: 0.5,
      radius: 0,
      useFillColorAsStroke: true,
      colorScale: {
        ranges: [
          {
            from: 0,
            to: 0.2,
            name: "Sehr trocken",
            color: "#c8642d",
          },
          {
            from: 0.201,
            to: 0.4,
            name: "Trocken",
            color: "#fac83c",
          },
          {
            from: 0.401,
            to: 0.5,
            name: "Beginn der Trockenheit",
            color: "#d9fa61",
          },
          {
            from: 0.501,
            to: 1,
            name: "Normal",
            color: "#82d732",
          },
          {
            from: 1.001,
            to: 2,
            name: "Sehr nass",
            color: "#0082fa",
          },
        ],
      },
    },
  },
  dataLabels: {
    enabled: false,
  },
  legend: {
    position: "bottom",
  },
  stroke: {
    width: 1,
  },
  title: {
    text: " Pflanzenverfügbares Wasser (nFK) in verschiedenen Tiefen",
    align: "center",
    style: {
      fontSize: "12px",
      fontWeight: "bold",
      //fontFamily:  undefined,
      //color:  '#263238'
    },
  },
  yaxis: {
    title: { text: "Bodentiefe [cm]" },
  },
  xaxis: {
    type: "datetime",
    title: { text: "Datum" },
    // min: new Date(startdate).getTime(),
    tickAmount: 6,
  },
};

var charth = new ApexCharts(document.getElementById("heatmapi"), optionsh);
charth.render();
